import { render, staticRenderFns } from "./ConfirmDeleteAssignmentModal.vue?vue&type=template&id=1b30f0fa&scoped=true&"
import script from "./ConfirmDeleteAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteAssignmentModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeleteAssignmentModal.vue?vue&type=style&index=0&id=1b30f0fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b30f0fa",
  null
  
)

export default component.exports